<template>
  <Component :is="typeof $route.meta.layout === 'function' ? $route.meta.layout() : $route.meta.layout">
    <RouterView />
  </Component>
  <AiAssistantWidget v-if="showAiAssistantWidget" />
  <HelpDrawer />
  <WLoading />
  <ConfirmationPane />
  <WTooltip />
  <SdfAlertToastContainer />
</template>

<script setup lang="ts">
import { SdfAlertToastContainer, WLoading, WTooltip } from '@pequity/shared/ui';
import { defineAsyncComponent } from 'vue';
import AiAssistantWidget from '@/ai-assistant/components/ai-assistant-widget/ai-assistant-widget.vue';
import { useAiAssistantWidget } from '@/ai-assistant/composables/useAiAssistantWidget';
import ConfirmationPane from '@/components/confirmation-pane/confirmation-pane.vue';
import { useIdleSessionTimeout } from '@/composables/useIdleSessionTimeout';
import { useOidcIdleGuard } from '@/composables/useOidcIdleGuard';
import { useHelpStore } from '@/stores/help';

defineOptions({
  name: 'App',
});

// Data
const helpStore = useHelpStore();
const { showAiAssistantWidget } = useAiAssistantWidget();
useIdleSessionTimeout();
useOidcIdleGuard();

// Async components
const HelpDrawer = defineAsyncComponent(async () => {
  helpStore.loading = true;
  const helpDrawer = await import('@/help/components/help-drawer.vue');
  helpStore.loading = false;

  return helpDrawer;
});
</script>
